/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Politics_Economics26Inputs */

const en__field__enum_teachingsubjectinterest_subject_politics_economics26 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Politics_Economics26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politics & Economics`)
};

const de__field__enum_teachingsubjectinterest_subject_politics_economics26 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Politics_Economics26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politik & Wirtschaft`)
};

/**
* | output |
* | --- |
* | "Politics & Economics" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Politics_Economics26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_politics_economics26 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Politics_Economics26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Politics_Economics26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_politics_economics26(inputs)
	return de__field__enum_teachingsubjectinterest_subject_politics_economics26(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_politics_economics26 as "_field__enum_teachingSubjectInterest_SUBJECT_POLITICS_ECONOMICS" }